import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from './Analytics.ts';
export function sendStoreTabsClickedAnalytic(tabName) {
    const eventData = {
        type: AnalyticEventType.StoreTabsClicked,
        category: AnalyticEventCategory.Store,
        stringValue: tabName
    };
    void CA.sendAnalyticEvent(eventData);
}
